import { useNavigate } from 'react-router-dom';

export default function CollectionShowcase() {
  const navigate = useNavigate();

  const collections = [
    {
      title: 'Men\'s Collection',
      description: 'Premium gear built for serious anglers',
      image: 'https://public.readdy.ai/ai/img_res/cd93e3e6ae5bc4756526a5d713ad0ab7.jpg',
      cta: 'Shop Men\'s',
      path: '/products'
    },
    {
      title: 'Women\'s Collection',
      description: 'Performance meets style on the water',
      image: 'https://readdy.ai/api/search-image?query=Professional%20female%20angler%20wearing%20premium%20fishing%20apparel%20on%20boat%2C%20ocean%20blue%20styling%2C%20confident%20pose%2C%20dramatic%20outdoor%20lifestyle%20photography%2C%20clean%20water%20background%2C%20high-end%20commercial%20style&width=800&height=1000&seq=womens-collection-v1&orientation=portrait',
      cta: 'Shop Women\'s',
      path: '/products'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
          {collections.map((collection, index) => (
            <div 
              key={index}
              className="group relative h-[600px] overflow-hidden rounded-lg cursor-pointer shadow-xl hover:shadow-2xl transition-all duration-500"
              onClick={() => navigate(collection.path)}
            >
              {/* Image */}
              <div className="absolute inset-0">
                <img 
                  src={collection.image} 
                  alt={collection.title}
                  className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/30 to-transparent"></div>
              </div>

              {/* Content */}
              <div className="absolute bottom-0 left-0 right-0 p-10 text-white">
                <h3 className="text-4xl font-black mb-3 uppercase tracking-tight">
                  {collection.title}
                </h3>
                <p className="text-lg mb-6 text-white/90 font-light">
                  {collection.description}
                </p>
                <button className="bg-white text-gray-900 hover:bg-cyan-600 hover:text-white px-8 py-4 rounded-md font-bold transition-all whitespace-nowrap uppercase tracking-wider text-sm">
                  {collection.cta}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
